module.exports = __webpack_public_path__ + "static/media/Cairo-SemiBold.6e44df1f.ttf";